import { useEffect, useRef } from "react";
import { useLiveRefresh } from "./useLiveRefresh";

// Existing mount/filter loads stay intact. Refresh only reruns read callbacks.
export const useRefreshRead = read => {
  const [version] = useLiveRefresh();
  const previous = useRef(version), callback = useRef(read);
  callback.current = read;
  useEffect(() => {
    if (previous.current !== version) {
      previous.current = version;
      callback.current();
    }
  }, [version]);
};